import type { OrderWorkflowTracker } from './order-workflow-tracking'

/** Read only our enum marker, never the input value or DOM text. */
export function trackOrderField(
    target: EventTarget | null,
    workflow?: OrderWorkflowTracker,
) {
    if (!(target instanceof Element)) return
    const group = target
        .closest('[data-order-group]')
        ?.getAttribute('data-order-group')
    if (
        group === 'customer' ||
        group === 'items' ||
        group === 'shipping' ||
        group === 'payment'
    )
        workflow?.interact(group)
}

/** Only field names determine the group; messages and values never leave the form. */
export function trackOrderValidation(
    errors: object,
    workflow?: OrderWorkflowTracker,
) {
    const groups = new Set<'customer' | 'items' | 'shipping' | 'payment'>()
    for (const key of Object.keys(errors)) {
        if (key.startsWith('shipping_')) groups.add('shipping')
        else if (key.startsWith('customer_') || key === 'source_channel')
            groups.add('customer')
        else if (key === 'items' || key === 'packaging_items')
            groups.add('items')
        else if (
            [
                'collect_cod',
                'apply_credit',
                'vat_percent',
                'vat_amount',
            ].includes(key)
        )
            groups.add('payment')
    }
    if (!groups.size)
        workflow?.step('validation_failed', { validationCode: 'invalid' })
    for (const fieldGroup of groups)
        workflow?.step('validation_failed', {
            fieldGroup,
            validationCode: 'invalid',
        })
}
